<template>
  <div class="immigration-page">
    <h1>移民申请</h1>
    
    <div class="card-grid">
      <!-- EE快速通道 -->
      <div class="card ee-card" @click="$router.push('/immigration/ee')">
        <h2>EE快速通道</h2>
        <div class="card-content">
          <p>快速通道是一个在线系统，用来管理移民技术类人员的移民申请。自2015年1月开始，加拿大移民部启用的新的移民系统。</p>
          <div class="program-list">
            <h3>包含项目：</h3>
            <div class="program-item" @click="$router.push('/immigration/fsw')">
              <span class="program-name">FSW项目</span>
              <p>基本要求：专业工作经验：过去10年中有1年连续的外，全职或相同时间的兼职的NOC TEER...</p>
            </div>
            <div class="program-item" @click="$router.push('/immigration/cec')">
              <span class="program-name">CEC项目</span>
              <p>基本要求：加拿大工作经验：过去3年中至少1年全职或相同时间的兼职的NOC TEER 0,...</p>
            </div>
            <div class="program-item" @click="$router.push('/immigration/fst')">
              <span class="program-name">FST项目</span>
              <p>基本要求：过去5年至少有2年全职或相同类part-time NOC TEER 2 or 3...</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 安省省提名OINP -->
      <div class="card oinp-card"  @click="$router.push('/immigration/oinp')">
        <h2>安省省提名OINP</h2>
        <div class="card-content">
          <p>加拿大省提名PNP项目 (Provincial Nominee Program) 是加拿大各省根据自身发展需要...</p>
          <div class="program-list">
            <h3>包含项目：</h3>
            <div class="program-item" @click="$router.push('/immigration/employer-sponsor')">
              <span class="program-name">安省雇主担保</span>
            </div>
            <div class="program-item" @click="$router.push('/immigration/graduate')">
              <span class="program-name">安省硕士/博士毕业生类项目</span>
            </div>
            <div class="program-item" @click="$router.push('/immigration/skilled-worker')">
              <span class="program-name">安省雇主需要的技术和经验类人才项目</span>
            </div>
            <div class="program-item"  @click="$router.push('/immigration/entrepreneur')">
              <span class="program-name">安省企业家移民</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 其他移民项目 -->
      <div class="card other-card">
        <h2>其他移民项目</h2>
        <div class="card-content">
          <div class="program-list">
            <div class="program-item" @click="$router.push('/immigration/suv')">
              <span class="program-name">创业移民SUV</span>
            </div>
            <div class="program-item" @click="$router.push('/immigration/self-employed')">
              <span class="program-name">自雇移民Self-employed</span>
            </div>
            <div class="program-item"  @click="$router.push('/immigration/rnip')">
              <span class="program-name">北方及偏远地区移民RNIP</span>
            </div>
            <div class="program-item" @click="$router.push('/immigration/afip')">
              <span class="program-name">农业食品项目移民AFIP</span>
            </div>
            <div class="program-item" @click="$router.push('/immigration/aip')">
              <span class="program-name">大西洋省份移民项目AIP</span>
            </div>
            <div class="program-item" @click="$router.push('/immigration/caregivers')">
              <span class="program-name">护理人员项目Caregivers</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 香港居民特殊通道移民 -->
      <div class="card hk-card">
        <h2>香港居民特殊通道移民</h2>
        <div class="card-content">
          <p>2021年6月，加拿大移民部宣布实施了一项专门针对香港居民申请加拿大永久居民的临时性政策。</p>
          <div class="program-list">
            <div class="program-item" @click="$router.push('/immigration/hk-graduate')">
              <span class="program-name">加拿大境内香港毕业生项目</span>
            </div>
            <div class="program-item" @click="$router.push('/immigration/hk-work-exp')">
              <span class="program-name">香港居民加拿大工作经验类项目</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 家庭团聚移民 -->
      <div class="card family-card">
        <h2  @click="$router.push('/immigration/family-reunion')">家庭团聚移民</h2>
        <div class="card-content">
          <p>按照加拿大移民部的规定，加拿大公民或永久居民可以担保其亲属移民加拿大。</p>
          <div class="program-list">
            <div class="program-item" @click="$router.push('/immigration/spouse-children')">
              <span class="program-name">担保配偶及子女</span>
            </div>
            <div class="program-item" @click="$router.push('/immigration/parents-grandparents')">
              <span class="program-name">担保父母祖父母</span>
            </div>
            <div class="program-item" @click="$router.push('/immigration/single-sponsor')">
              <span class="program-name">单身担保家庭成员</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImmigrationView'
}
</script>

<style lang="less" scoped>
.immigration-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  h1 {
    text-align: center;
    margin-bottom: 40px;
    color: #333;
    font-size: 32px;
  }

  .card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
  }

  .card {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
    overflow: hidden;

    &:hover {
      transform: translateY(-5px);
    }

    h2 {
      margin: 0;
      padding: 15px 20px;
      color: #fff;
      font-size: 20px;
      background: #e23a2e;
    }

    .card-content {
      padding: 20px;

      p {
        color: #666;
        line-height: 1.6;
        margin-bottom: 20px;
      }

      h3 {
        color: #333;
        margin: 15px 0;
        font-size: 18px;
      }
    }
  }

  .program-list {
    .program-item {
      margin: 15px 0;
      padding: 10px;
      border-radius: 6px;
      background: #f8f8f8;
      transition: background-color 0.3s ease;

      &:hover {
        background: #f0f0f0;
      }

      .program-name {
        display: block;
        color: #e23a2e;
        font-weight: bold;
        margin-bottom: 5px;
      }

      p {
        margin: 5px 0 0;
        font-size: 14px;
        color: #666;
      }
    }
  }

  @media (max-width: 768px) {
    .card-grid {
      grid-template-columns: 1fr;
    }

    h1 {
      font-size: 28px;
    }
  }
}
</style>